<template>
  <div class="criterio-select-lojas">
    <v-row>
      <v-col class="py-0" align="center">
        <select-highlights
          :selected.sync="highlights"
          :loading="loadingInitialState"
          :status="['ACTIVE', 'FINISHED']"
          :disable-save="disableSave"
          :tooltip-primary-button="tooltipPrimaryButton"
          :tooltip-primary-button-message="tooltipPrimaryButtonMessage"
          default-table-sort-by="updatedAt"
          default-table-sort-desc
          :disabled="disabled"
          single-line
          hide-details
        />
      </v-col>
    </v-row>
    <v-chip-group column active-class="primary--text">
      <v-chip
        v-for="(highlight, index) in highlights"
        :key="`${index}-loaded`"
        class="disabled-chip"
        small
        :close="!disabled"
        :ripple="false"
        @click:close="removeSelectedHighlight(index)"
      >
        <span>{{ truncate(highlight.title) }}</span>
      </v-chip>
    </v-chip-group>

    <v-chip-group v-if="loadingInitialState" column active-class="primary--text">
      <v-chip v-for="(highlight, index) in initialValue" :key="`${index}-loading`" class="disabled-chip" small :ripple="false">
        <v-progress-circular indeterminate color="primary" size="15" />
      </v-chip>
    </v-chip-group>
  </div>
</template>

<script>
import truncate from 'lodash/truncate'
import cloneDeep from 'lodash/cloneDeep'
import { mapState, mapActions } from 'vuex'
import SelectHighlights from '@/components/select-highlights/SelectHighlights.vue'
import { QUERY_GET_HIGHLIGHTED_OFFERS } from '@/modules/mobile/destaques/graphql'

export default {
  components: {
    SelectHighlights,
  },
  props: {
    label: String,
    currentIndex: Number,
    initialValue: {
      type: [Array, Number],
      default: () => {
        return []
      },
    },
    values: {
      type: [Array, Number],
      default: () => {
        return []
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disableSave: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    highlights: [],
    loadingInitialState: false,
  }),

  computed: {
    ...mapState({}),
    tooltipPrimaryButton() {
      return this.disableSave
    },
    tooltipPrimaryButtonMessage() {
      return this.disableSave ? 'Não é possível alterar um segmento estático' : ''
    },
    highlightDates() {
      if (!this.highlights) return null
      return this.highlights.reduce(
        (acc, highlight) => {
          if (highlight.initialDate < acc.min) acc.min = highlight.initialDate
          if (highlight.finalDate > acc.max) acc.max = highlight.finalDate
          return acc
        },
        { min: this.highlights[0].initialDate, max: this.highlights[0].finalDate }
      )
    },
  },

  watch: {
    highlights(highlights) {
      this.$emit('input', { currentValue: highlights.map(({ id }) => `'${id}'`), currentChildren: this.values[0], currentIndex: this.currentIndex })
      this.validate()
      this.setHighlightProducts([...new Set(highlights.flatMap((highlight) => highlight.products.map((product) => product.sku)))])
      this.setHighlightDates([this.highlightDates.min.replace(/-/g, ''), this.highlightDates.max.replace(/-/g, '')])
    },
  },

  async mounted() {
    if (this.initialValue && this.initialValue.length) {
      await this.setInitialState(this.initialValue)
    }
    this.validate()
  },

  methods: {
    ...mapActions(['setHighlightProducts', 'setHighlightDates']),
    truncate(value) {
      return truncate(value, { length: 40, separator: ' ' })
    },
    validate() {
      this.$emit('validate', { isValid: this.isValid(), currentIndex: this.currentIndex })
    },

    isValid() {
      return Boolean(this.highlights && this.highlights.length)
    },

    async setInitialState(highlightIds) {
      const normalizedHighlightIds = highlightIds.map((id) => id.replace(/'/g, ''))
      try {
        this.loadingInitialState = true
        const {
          data: {
            highlightedOffers: { highlightedOffers },
          },
        } = await this.$apollo.query({
          query: QUERY_GET_HIGHLIGHTED_OFFERS,
          fetchPolicy: 'network-only',
          variables: {
            highlightIds: normalizedHighlightIds,
            page: 1,
            pageSize: 10000,
            franchise: false,
          },
        })
        this.highlights = highlightedOffers.filter((highlight) => normalizedHighlightIds.includes(highlight.id))
      } catch {
        this.$snackbar({ message: 'Falha ao comunicar com o servidor.' })
      }

      this.loadingInitialState = false
    },

    removeSelectedHighlight(index) {
      const highlights = cloneDeep(this.highlights)
      highlights.splice(index, 1)
      this.highlights = highlights
    },
  },
}
</script>

<style lang="scss">
.criterio-select-lojas {
  .select-container {
    padding: 0 15px;
  }
}
</style>
